import { publicRequest } from "../../../requestMeth";

export const getPassiveLoadSchedules = async (token, params = {}) => {
  const res = await publicRequest.get('/analysis/passive-load/schedule', {
    headers: { token: `Bearer ${token}` },
    params,
  });
  return res.data;
};

export const createPassiveLoadSchedule = async (token, payload) => {
  const res = await publicRequest.post('/analysis/passive-load/schedule', payload, {
    headers: { token: `Bearer ${token}` },
  });
  return res.data;
};

export const updatePassiveLoadSchedule = async (token, id, payload) => {
  const res = await publicRequest.put(`/analysis/passive-load/schedule/${id}`, payload, {
    headers: { token: `Bearer ${token}` },
  });
  return res.data;
};

export const deletePassiveLoadSchedule = async (token, id) => {
  const res = await publicRequest.delete(`/analysis/passive-load/schedule/${id}`, {
    headers: { token: `Bearer ${token}` },
  });
  return res.data;
};

export const getPassiveLoadSettings = async (token, params = {}) => {
  const res = await publicRequest.get('/analysis/passive-load/settings', {
    headers: { token: `Bearer ${token}` },
    params,
  });
  return res.data;
};

export const createPassiveLoadSettings = async (token, payload) => {
  const res = await publicRequest.post('/analysis/passive-load/settings', payload, {
    headers: { token: `Bearer ${token}` },
  });
  return res.data;
};

export const updatePassiveLoadSettings = async (token, id, payload) => {
  const res = await publicRequest.put(`/analysis/passive-load/settings/${id}`, payload, {
    headers: { token: `Bearer ${token}` },
  });
  return res.data;
};

export const deletePassiveLoadSettings = async (token, id) => {
  const res = await publicRequest.delete(`/analysis/passive-load/settings/${id}`, {
    headers: { token: `Bearer ${token}` },
  });
  return res.data;
};

export const getPassiveLoadExceptions = async (token, params = {}) => {
  const res = await publicRequest.get('/analysis/passive-load/exceptions', {
    headers: { token: `Bearer ${token}` },
    params,
  });
  return res.data;
};

export const createPassiveLoadException = async (token, payload) => {
  const res = await publicRequest.post('/analysis/passive-load/exceptions', payload, {
    headers: { token: `Bearer ${token}` },
  });
  return res.data;
};

export const updatePassiveLoadException = async (token, id, payload) => {
  const res = await publicRequest.put(`/analysis/passive-load/exceptions/${id}`, payload, {
    headers: { token: `Bearer ${token}` },
  });
  return res.data;
};

export const deletePassiveLoadException = async (token, id) => {
  const res = await publicRequest.delete(`/analysis/passive-load/exceptions/${id}`, {
    headers: { token: `Bearer ${token}` },
  });
  return res.data;
};
